import { useEffect } from "react";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export function useSeo({ title, description, path = "/", jsonLd, noindex = false }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = `${window.location.origin}${path}`;
    let script = null;
    if (ld) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seo = "page";
      script.textContent = ld;
      document.head.appendChild(script);
    }
    if (noindex) setMeta("name", "robots", "noindex, nofollow");
    return () => {
      if (script) script.remove();
      if (noindex) document.head.querySelector('meta[name="robots"]')?.remove();
    };
  }, [title, description, path, ld, noindex]);
}
